import { extendTheme } from '@chakra-ui/react';

const baseTheme = extendTheme({
  components: {
    Button: {
      baseStyle: {
        _disabled: {
          backgroundColor: 'grey.500',
          cursor: 'not-allowed',
          color: 'black',
        },
      },
    },
  },
});

export { baseTheme };
